/**
 * Mobil "Daha Fazla" menüsü için grup başlıkları.
 * Sidebar.tsx'teki G2–G9 grup kimlikleri/etiketleriyle birebir aynıdır;
 * 'ana-alan' Sidebar'ın grupsuz üst bölümüne (G1) karşılık gelir.
 * Sidebar accordion yapısını kendi içinde tuttuğu için bu meta yalnızca
 * mobil menüde kullanılır (etiketler tek kaynak: bu dosya).
 */
export interface MobileNavGroupMeta {
  id: string;
  label: string;
}

export const MOBILE_NAV_GROUPS: MobileNavGroupMeta[] = [
  { id: 'ana-alan', label: 'Ana Alan' },
  { id: 'saha-operasyonu', label: 'Saha Operasyonu' },
  { id: 'isg-uyum', label: 'İSG & Uyum' },
  { id: 'finans-satis', label: 'Finans & Satış' },
  { id: 'teknik-ofis', label: 'Teknik Ofis' },
  { id: 'tedarik-ekipman', label: 'Tedarik & Ekipman' },
  { id: 'analiz-ai', label: 'Analiz & AI' },
  { id: 'yonetim', label: 'Yönetim' },
  { id: 'hesap', label: 'Hesap' },
];
